import { Typography } from '@mui/material'
import React, { useState } from 'react'
import { NotificationPrompt, Profile } from '../components/Common'
import Patient_profile from '../components/Patient_profile'

export default function Test() {

  return (
    <div>
      <Patient_profile></Patient_profile>
    </div>
  )
}
